import { useUser } from "@/hooks/useUser";
import { getStatusIcon } from "@/utils/status-utils";
import type { EstimateStatus } from "@rebuild/shared";

interface EstimateStatusBadgeProps {
  status?: EstimateStatus;
}

export const EstimateStatusBadge = ({ status }: EstimateStatusBadgeProps) => {
  const { currentUser } = useUser();
  if (!status) return <></>;

  // Try to find a custom status with matching name
  const customStatus = currentUser?.extraData?.customSettings?.status?.find((s) => s.name === status);

  // Get icon based on status name
  const icon = getStatusIcon(status);

  // Get custom color if available
  const colorStyle = customStatus?.color ? { color: customStatus.color } : {};

  return (
    <div className="inline-flex max-w-full items-center space-x-2 rounded-full border border-[#eeeff1] p-1 !pr-2 text-sm font-medium">
      {icon}
      <p className="truncate text-xs" style={colorStyle}>
        {status}
      </p>
    </div>
  );
};
